var map = {
	"./battery-replacement.png": "ef95",
	"./battery-status.png": "bd51",
	"./code-of-conduct.png": "2c1f",
	"./crosshair.png": "8450",
	"./follow-up.png": "160b",
	"./fonts/KeepIconRegular.woff": "e77b",
	"./fonts/KeepIconRegular.woff2": "62ce",
	"./icons/certifier.png": "1154",
	"./icons/distributor.png": "348a",
	"./icons/endofuse.png": "9d03",
	"./icons/importer.png": "2189",
	"./icons/manufacturer.png": "fd12",
	"./icons/producer.png": "6360",
	"./icons/reseller.png": "8187",
	"./icons/seller.png": "d1f3",
	"./icons/service.png": "b4e7",
	"./icons/shipping.png": "b943",
	"./illustrations/onboarding/Certifier1.png": "c67d",
	"./illustrations/onboarding/Certifier2.png": "d8ab",
	"./illustrations/onboarding/Producer1.png": "107f",
	"./illustrations/onboarding/Producer2.png": "ddca",
	"./illustrations/onboarding/Producer3.png": "b61d",
	"./illustrations/onboarding/Producer4.png": "6f98",
	"./illustrations/onboarding/Recycler1.png": "1ce0",
	"./illustrations/onboarding/Recycler2.png": "a349",
	"./illustrations/onboarding/Remanufacturing1.png": "4f4f",
	"./illustrations/onboarding/Service1_Remanufacturing2.png": "dcab",
	"./illustrations/onboarding/Service2.png": "0b78",
	"./illustrations/onboarding/Users1.png": "8f93",
	"./illustrations/onboarding/Users2.png": "419b",
	"./illustrations/onboarding/Users3.png": "089c",
	"./illustrations/onboarding/Users4.png": "4403",
	"./keep-logo-inverted.png": "edfc",
	"./keep-logo.png": "f3ae",
	"./keyboard-replacement.png": "386f",
	"./lenovo-manual.png": "4f20",
	"./logos/github-mark.svg": "49fa",
	"./logos/hp.jpeg": "4d1d",
	"./logos/keepLogo.png": "62b8",
	"./logos/lenovo.png": "2c71",
	"./no-image.png": "bd21",
	"./parts/battery-icon.png": "4cfe",
	"./parts/camera.png": "c735",
	"./parts/control-panel.png": "4b19",
	"./parts/cpu-icon.png": "3ded",
	"./parts/display-icon.png": "d666",
	"./parts/glass-jug.png": "da51",
	"./parts/gpu-icon.png": "b560",
	"./parts/power-cord.png": "988f",
	"./parts/value-icon.png": "0b48",
	"./products/CO443726(3).png": "c90d",
	"./products/CO443726.png": "f4df",
	"./products/LightSpeaker.png": "213e",
	"./products/LightSpeakerWhite.png": "6d30",
	"./products/cz134902dn.jpeg": "09a4",
	"./products/czc5082dxt.jpeg": "9c24",
	"./products/iphone.jpeg": "2389",
	"./products/keepLaptop.png": "dd76",
	"./products/laptop.png": "9b9b",
	"./products/lenovo-laptop.png": "92e4",
	"./products/lenovo_x1yoga.png": "5af7",
	"./products/s4h99126.jpeg": "1acc",
	"./products/s4s76851.jpeg": "b073",
	"./products/voxicon-d27qo.jpg": "ecdf",
	"./products/voxicon-d27qo.png": "845d",
	"./roles/certifier.svg": "e940",
	"./roles/consumer.svg": "4c47",
	"./roles/producer.svg": "3ccd",
	"./roles/recycler.svg": "dc66",
	"./roles/remanufacturer.png": "690d",
	"./roles/remanufacturer.svg": "2015",
	"./roles/service.svg": "44de",
	"./security-status.png": "06b8",
	"./smileys/smiley_1.svg": "cb25",
	"./smileys/smiley_2.svg": "5c4d",
	"./smileys/smiley_3.svg": "6422",
	"./smileys/smiley_4.svg": "49c0",
	"./smileys/smiley_5.svg": "e592",
	"./temp-status.png": "802a",
	"./troubleshoot.png": "0767"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";